import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ListSubheader from '@mui/material/ListSubheader';
import { useCategory } from '../../CategoryContext';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

const VerticalSelector = ({ vertical_id }) => {
  const { verticals } = useCategory();
  const navigate = useNavigate();
  let filteredVerticals = verticals.filter((v) => v.status === 'Joined' || v.status === 'Created');
  const draftVerticals = filteredVerticals.filter(
    (v) => v.status === 'Created' && (v.invited_count || 0) === 0
  );
  const myVerticals = filteredVerticals.filter(
    (v) => v.status === 'Created' && (v.invited_count || 0) > 0
  );
  const joinedVerticals = filteredVerticals.filter((v) => v.status === 'Joined');

  const [selectedVertical, setSelectedVertical] = useState(null);

  useEffect(() => {
    if (filteredVerticals.length > 0) {
      const foundVertical = filteredVerticals.find((v) => v.id === vertical_id) || null;
      setSelectedVertical(foundVertical);
    }
  }, [verticals, vertical_id]);

  const handleChange = (event) => {
    const newSelectedVertical = filteredVerticals.find((v) => v.id === event.target.value);

    let updatedPath = `/vertical/${newSelectedVertical.id}/home`;

    navigate(updatedPath);
  };

  const headerStyles = {
    display: 'flex',
    justifyContent: 'flex-start',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '24px',
    color: '#344054',
    backgroundColor: '#FFFFFF',
    borderBottom: '2px solid #344054',
    paddingX: '16px',
  };

  const getItemStyles = (showDivider) => ({
    borderBottom: showDivider ? '1px solid #EAECF0' : 'none',
    maxWidth: '200px',
    paddingY: '6px',
    marginX: '1px',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '24px',
    color: '#344054',
    '&.Mui-selected': {
      backgroundColor: '#DEEAFF',
      color: '#006ED4',
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#DEEAFF',
    },
  });

  return (
    filteredVerticals.length > 0 && (
      <Box sx={{ minWidth: 120 }}>
        <FormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedVertical?.id || ''}
            onChange={handleChange}
            sx={{
              height: '40px',
              marginBottom: '20px',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '20px',
              color: '#344054',
              boxShadow: '0px 2px 8px 0px #1018281A',
            }}
          >
            {draftVerticals.length > 0 && (
              <ListSubheader sx={headerStyles}>
                Private Verticals
              </ListSubheader>
            )}
            {draftVerticals.map((v, i) => (
              <MenuItem
                value={v.id}
                key={v.id}
                sx={getItemStyles(i < draftVerticals.length - 1 || myVerticals.length > 0 || joinedVerticals.length > 0)}
              >
                <Box
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {v.name}
                </Box>
              </MenuItem>
            ))}
            {myVerticals.length > 0 && (
              <ListSubheader sx={headerStyles}>My Verticals</ListSubheader>
            )}
            {myVerticals.map((v, i) => (
              <MenuItem
                value={v.id}
                key={v.id}
                sx={getItemStyles(i < myVerticals.length - 1 || joinedVerticals.length > 0)}
              >
                <Box
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {v.name}
                </Box>
              </MenuItem>
            ))}
            {joinedVerticals.length > 0 && (
              <ListSubheader sx={headerStyles}>
                Joined Verticals
              </ListSubheader>
            )}
            {joinedVerticals.map((v, i) => (
              <MenuItem
                value={v.id}
                key={v.id}
                sx={getItemStyles(i < joinedVerticals.length - 1)}
              >
                <Box
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {v.name}
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    )
  );
};

export default VerticalSelector;
